module.exports = __webpack_public_path__ + "media/site/images/icons/db-icon-ac721f5fb9cfcea66842d9e35f357491.svg";